import module from 'contabilidad/clientescuentascontables/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('contabilidad.clientesCuentasContables.cliente.cuentas', {
    url: '',
    data: {
      title: '{{clientes.Nombre}}',
    },
    resolve: {
      data: (ContabilidadClientesCuentasContables, idCliente) => ContabilidadClientesCuentasContables.obtenerCuentasContables(idCliente)
        .then(({data}) => data),
    },
    template: '<contabilidad-clientescuentascontables-detalle-cuentas data="data"/>',
    controller: ($scope, data) => {
      $scope.data = data
    },
  })
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/routes/contabilidad/clientesCuentasContables/lista/detalle/cuentas.js